export enum Salutation {
  'Unknown',
  'Mrs',
  'Dr',
  'Mr',
  'Ms',
  'Miss',
  'Prof',
}
